import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, Support, SupportComment, SupportDetail, SupportHttpResponse, TicketResponse } from "../interfaces";
import { CommonWebService } from "./commonweb.service";
import { UserHttpService } from "./user-session.service";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  constructor(
    private http: HttpClient,
    private commmonService: CommonWebService,
    private userSessionService: UserHttpService
  ) { }

  //Support list
  public getSupportList(limit?: number, offset?: number,): Observable<HttpResponse<TicketResponse>> {
    const formData = new FormData();
    formData.append('user_id', this.userSessionService.getUserInfo.user_id);
    formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append('token', this.userSessionService.userToken);
    if (limit !== undefined) {
      formData.append('limit', limit.toString());
    }
    if (offset !== undefined) {
      formData.append('offset', offset.toString());
    }
    return this.http.post<HttpResponse<TicketResponse>>('support/generateTicket/ticketlist', formData);
  }

  // Create Ticket
  public createTicket(body: Support): Observable<HttpResponse<any>> {
    const formData = new FormData();
    formData.append('user_id', this.userSessionService.getUserInfo.user_id);
    formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append('token', this.userSessionService.userToken);
    formData.append('first_name', body.first_name);
    formData.append('last_name', body.last_name);
    formData.append('organisation', body.organisation);
    formData.append('designation', body.designation);
    formData.append('issue_type', body.issue_type);
    formData.append('ticket_description', body.ticket_description);
    formData.append('employee_id', body.employee_id);
    formData.append('email_id', body.email_id);
    formData.append('contact_no', body.contact_no);
    return this.http.post<HttpResponse<any>>('support/generateTicket/', formData);
  }

  // Update ticket status
  public updateTicketStatus(event: string, ticketId: string): Observable<HttpResponse<any>> {
    const formData = new FormData();
    formData.append('user_id', this.userSessionService.getUserInfo.user_id);
    formData.append('token', this.userSessionService.userToken);
    formData.append('ticket_id', ticketId);
    formData.append('ticket_status', event);
    return this.http.post<HttpResponse<any>>('support/generateTicket/updateticketstatus', formData);
  }

  // Reply ticket
  public replyToTicket(sender_id: string, ticket_reply: string, ticketId: string): Observable<HttpResponse<any>> {
    const formData = new FormData();
    formData.append('user_id', this.userSessionService.getUserInfo.user_id);
    formData.append('token', this.userSessionService.userToken);
    formData.append('ticket_id', ticketId);
    formData.append('ticket_reply', ticket_reply);
    formData.append('sender_id', sender_id);
    return this.http.post<HttpResponse<any>>('support/generateTicket/ticketresponse', formData);
  }

  //Ticket Detail
  public getTicketDetail(ticketId: string): Observable<SupportHttpResponse<SupportDetail[], SupportComment[]>> {
    const formData = new FormData();
    formData.append('user_id', this.userSessionService.getUserInfo.user_id);
    formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append('token', this.userSessionService.userToken);
    formData.append('ticket_id', ticketId);
    return this.http.post<SupportHttpResponse<SupportDetail[], SupportComment[]>>("support/generateTicket/ticketdetail", formData);
  }
}
